export interface ILoginPageVM {
      loginId: string;
      password: string;
      errorMessage: string;
      appVersion: string;
}
export const LoginPageVM: ILoginPageVM = {
      loginId: '',
      password: '',
      errorMessage: '',
      appVersion: ''
};
export interface IResponseDto<T> {
      status: string;
      message: string;
      timestamp: string;
      data: T;
}
export interface IAuthUserDto {
      userId: number;
      userName: string;
      displayName: string;
      apiKey: string;
      accessRights: string;
}
export interface IAttendanceDto {
      attendanceId: number;
      attendanceDate: Date;
      fromDate: Date;
      toDate: Date;
      className: string;
      studentName: string;
      sectionName: string;
      studentId: number;
      morningAttendance: boolean;
      afternoonAttendance: boolean;
      morningAttendanceSum: number;
      afternoonAttendanceSum: number;
      totalAttendance: number;
      showMorningAttendance: boolean;
      showAfternoonAttendance: boolean;
}
export const AttendancePageVM: IResponseDto<IAttendanceDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            attendanceId: null,
            attendanceDate: null,
            fromDate: null,
            toDate: null,
            studentName: '',
            className: '',
            sectionName: '',
            studentId: null,
            morningAttendance: true,
            afternoonAttendance: false,
            morningAttendanceSum: null,
            afternoonAttendanceSum: null,
            totalAttendance: null,
            showMorningAttendance: true,
            showAfternoonAttendance: false
      }]
};
export interface IAttendanceOnlyDto {
      attendanceDate: Date;
      morningActualAttendance: number;
      afternoonActualAttendance: number;
      morningTotalAttendance: number;
      afternoonTotalAttendance: number;
}
export const AttendanceOnlyPageVM: IResponseDto<IAttendanceOnlyDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            attendanceDate: null,
            morningActualAttendance: null,
            afternoonActualAttendance: null,
            morningTotalAttendance: null,
            afternoonTotalAttendance: null
      }
};
export interface ICircularDto {
      circularId: number;
      circularTitle: string;
      circularContent: string;
      triggerDatetime: Date;
      circularDate: string;
      crDate: string;
      crMonth: string;
      crYear: string;
      fileName: string;
      fileUrl: string;
      visited: boolean;
      attachmentCount: number;
}
export const CircularPageVM: IResponseDto<ICircularDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            circularId: null,
            circularTitle: '',
            circularContent: '',
            triggerDatetime: null,
            circularDate: '',
            crDate: '',
            crMonth: '',
            crYear: '',
            fileName: null,
            fileUrl: null,
            visited: false,
            attachmentCount: null,
      }]
};
export interface INotificationDto {
      notificationId: number;
      notificationTitle: string;
      notificationContent: string;
      triggerDatetime: string;
      triggerDate: string;
      notificationClassId: number;
      classId: number;
      notificationNotificationTitle: string;
      notificationNotificationContent: string;
      notificationTriggerDatetime: string;
      notificationInsertUserId: number;
      notificationInsertDate: string;
      notificationUpdateUserId: number;
      notificationUpdateDate: string;
      classClassName: string;
      classDescription: string;
      studentId: number;
      truncating: boolean;
      isViewed: boolean;
}
export const NotificationPageVM: IResponseDto<INotificationDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            notificationId: null,
            notificationTitle: null,
            notificationContent: null,
            triggerDatetime: null,
            triggerDate: null,
            notificationClassId: null,
            classId: null,
            notificationNotificationTitle: null,
            notificationNotificationContent: null,
            notificationTriggerDatetime: null,
            notificationInsertUserId: null,
            notificationInsertDate: null,
            notificationUpdateUserId: null,
            notificationUpdateDate: null,
            classClassName: null,
            classDescription: null,
            studentId: null,
            truncating: false,
            isViewed: false
      }]
};
export interface IStudentDto {
      studentId: number;
      applicationNo: string;
      admissionNo: string;
      studentName: string;
      dob: Date;
      gender: string;
      bloodGroup: string;
      previousSchool: string;
      studentAadhaar: string;
      fatherName: string;
      fatherPhoneNo: string;
      fatherEmail: string;
      fatherOccupation: string;
      fathersCompany: string;
      fathersAadhaar: string;
      motherName: string;
      motherPhoneNo: string;
      motherEmail: string;
      motherOccupation: string;
      mothersAadhaar: string;
      mothersCompany: string;
      emergencyContactNo: string;
      address: string;
      religion: string;
      cast: string;
      House: string;
      studentAadharDoc: boolean;
      fatherAadharDoc: boolean;
      motherAadharDoc: boolean;
      originalTcDoc: boolean;
      birthCertificate: boolean;
      transportAuthorisationDoc: boolean;
      otherDoc: string;
      remarks: string;
      photoUrl: string;
      mothertounge: string;
      admissionDate: string;
      dateofbirth: string;
      ClassId: number;
      className: string;
      description: string;
      studentClassSectionId: number;
      anualFee: number;
      academicYear: string;
      sectionId: number;
      sectionName: string;
      sectionDescription: string;

}
export const StudentPageVM: IResponseDto<IStudentDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            studentId: null,
            applicationNo: '',
            admissionNo: '',
            studentName: '',
            dob: null,
            gender: '',
            bloodGroup: '',
            previousSchool: '',
            studentAadhaar: '',
            fatherName: '',
            fatherPhoneNo: '',
            fatherEmail: '',
            fatherOccupation: '',
            fathersCompany: '',
            fathersAadhaar: '',
            motherName: '',
            motherPhoneNo: '',
            motherEmail: '',
            motherOccupation: '',
            mothersAadhaar: '',
            mothersCompany: '',
            emergencyContactNo: '',
            address: '',
            religion: '',
            cast: '',
            House: '',
            studentAadharDoc: false,
            fatherAadharDoc: false,
            motherAadharDoc: false,
            originalTcDoc: false,
            birthCertificate: false,
            transportAuthorisationDoc: false,
            otherDoc: '',
            remarks: '',
            photoUrl: '',
            mothertounge: '',
            admissionDate: '',
            dateofbirth: '',
            ClassId: null,
            className: '',
            description: '',
            studentClassSectionId: null,
            anualFee: null,
            academicYear: '',
            sectionId: null,
            sectionName: '',
            sectionDescription: '',
      }]
};
export interface ITimeTableDto {
      termName: string;
      className: string;
      examName: string;
      subjectGroupName: string;
      subjectName: string;
      skillGroupName: string;
      skillName: string;
      happenon: Date;
      fileUrl: string;
}
export const TimeTablePageVM: IResponseDto<ITimeTableDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            termName: '',
            className: '',
            examName: '',
            subjectGroupName: '',
            subjectName: '',
            skillGroupName: '',
            skillName: '',
            happenon: null,
            fileUrl: '',
      }]
};
export interface IStudentFeeDto {
      studentid: number;
      classid: number;
      anualfee: number;
      academicyear: string;
      studentname: string;
      gender: string;
      classname: string;
      dob: Date;
      amountpaid: number;
      dueamount: number;
      admissionno: string;
      applicationno: string;
}
export const StudentFeePageVM: IResponseDto<IStudentFeeDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            studentid: 0,
            classid: 0,
            anualfee: 0,
            academicyear: '',
            studentname: '',
            gender: '',
            classname: '',
            dob: null,
            amountpaid: 0,
            dueamount: 0,
            admissionno: '',
            applicationno: '',
      }
};
export interface IStudentBaseDto {
      studentId: number;
      studentName: string;
      fatherName: string;
      className: string;
      classId: number;
      fatherPhoneNo: string;
      photoUrl: string;
}
export const ParentHomePageVM: IResponseDto<IStudentBaseDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            studentId: null,
            studentName: '',
            fatherName: '',
            fatherPhoneNo: '',
            photoUrl: '',
            className: '',
            classId: null,
      }]
};
export interface ISchoolHolidaysDto {
      holidayid: number;
      holidayname: string;
      holidaydate: Date;
      description: string;
}
export const SchoolHolidaysPageVM: IResponseDto<ISchoolHolidaysDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            holidayid: 0,
            holidayname: '',
            holidaydate: null,
            description: ''
      }]
};
export interface IGradeDto {
      fileName: string;
      fileUrl: string;
}
export const GradePageVM: IResponseDto<IGradeDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            fileName: null,
            fileUrl: null
      }
};
export interface IExamNamesDto {
      examname: string;
}
export const ExamNamesDtoPageVM: IResponseDto<IExamNamesDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            examname: '',
      }]
};
export interface IGetAttendanceDto {
      studentId: number;
      noontype: string;
      // fromDate: Date;
      // toDate: Date;
}
export const GetAttendancePageVM: IResponseDto<IGetAttendanceDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            studentId: 0,
            noontype: '',
            // fromDate: null,
            // toDate: null
      }
};
export interface IEventTypeDto {
      eventTypeName: string;
      eventTypeID: number;

}
export const EventTypePageVM: IResponseDto<IEventTypeDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            eventTypeName: '',
            eventTypeID: null,
      }]
};
export interface IEventNamesDto {
      eventID: number;
      eventName: string;
      eventClass: string;
      description: string;
      eventTypeID: number;
}
export const EventNamesPageVM: IResponseDto<IEventNamesDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            eventID: null,
            eventName: '',
            eventClass: '',
            description: '',
            eventTypeID: null,
      }]
};
export interface IEventImagesDto {
      eventImageId: number;
      eventID: number;
      imageName: string;
      imageUrl: string;
}
export const EventImagesPageVM: IResponseDto<IEventImagesDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            eventImageId: null,
            eventID: null,
            imageName: '',
            imageUrl: '',
      }]
};
export interface IReminderDto {
      reminderId: number;
      className: string;
      description: string;
      startDate: Date;
      endDate: Date;
      toDayDate: Date;

}
export const ReminderPageVM: IResponseDto<IReminderDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            reminderId: null,
            className: '',
            startDate: null,
            endDate: null,
            description: '',
            toDayDate: null,
      }]
};
export interface IChangePasswordDto {
      oldPassword: string;
      newPassword: string;
      confirmPassword: string;
      message: string;

}
export const ChangePasswordPageVM: IResponseDto<IChangePasswordDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            message: '',
      }
};
export interface IForgotPasswordDto {
      loginId: string;
      emailId: string;
      errorMessage: string;
}
export const ForgotPasswordPageVM: IResponseDto<IForgotPasswordDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            loginId: '',
            emailId: '',
            errorMessage: '',
      }
};
export interface IPaymentHistoryDto {
      receiptNo: string;
      studentID: number;
      className: string;
      sectionName: string;
      paidAmount: number;
      paymentMode: string;
      transactionNo: string;
      paymentDate: string;
      paymentBank: string;
}
export const PaymentHistoryPageVM: IResponseDto<IPaymentHistoryDto[]> = {
      status: '',
      message: '',
      timestamp: '',
      data: [{
            receiptNo: '',
            studentID: null,
            className: '',
            sectionName: '',
            paidAmount: null,
            paymentMode: '',
            transactionNo: '',
            paymentDate: '',
            paymentBank: '',
      }]
};
export interface IPushRegDto {
      oneSignalKey: string;
      parentUserId: number;
}
export const PushRegisterPageVM: IResponseDto<IPushRegDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            oneSignalKey: '',
            parentUserId: null,
      }
};
export interface IFeeInvoiceDto {
      url: string;
      message: string;
}
export const FeeInvoicePageVM: IResponseDto<IFeeInvoiceDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            url: null,
            message: null
      }
};
export interface ISchoolConfigurationDto {
      configurationid: number;
      devapplicationhostname: string;
      devapihostname: string;
      prodapplicationhostname: string;
      prodapihostname: string;
      principalname: string;
      acadamicyear: string;
      schoolstartdate: Date;
      schoolenddate: Date;
}
export const SchoolConfigurationPageVM: IResponseDto<ISchoolConfigurationDto> = {
      status: '',
      message: '',
      timestamp: '',
      data: {
            configurationid: null,
            devapplicationhostname: '',
            devapihostname: '',
            prodapplicationhostname: '',
            prodapihostname: '',
            principalname: '',
            acadamicyear: '',
            schoolstartdate: null,
            schoolenddate: null
      }
};



